import * as Sentry from '@sentry/react';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import './i18n/config';
import { routeTree } from './routeTree.gen';
import { initA11y } from './stores/a11y';
import { captureExamFragment, isExamGuestPath } from './features/mockExams/guest/protectLink';

initA11y();
captureExamFragment();

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn && !isExamGuestPath()) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    beforeSend: (event) => (isExamGuestPath() ? null : event),
    beforeSendTransaction: (event) => (isExamGuestPath() ? null : event),
    beforeBreadcrumb: (breadcrumb) => (isExamGuestPath() ? null : breadcrumb),
  });
}

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
